import store from '../store'
import { isIOS } from './device.js'
import * as INTF from '@/api/interface.js'

// localStorage
export function setLocalStorage(key, value) {
  localStorage[key] = JSON.stringify(value)
}
export function getLocalStorage(key) {
  if (typeof localStorage[key] === 'string') {
    return localStorage[key]
  } else {
    return localStorage[key] ? JSON.parse(localStorage[key]) : ''
  }
}
// 获取url参数
export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
// 获取token
export function getSyncToken() {
  let storage = localStorage['__token']
  if (!storage) {
    return ''
  }
  let currentTokenInfo = storage
  if (currentTokenInfo) {
    // 将缓存中的token信息 ，加入store
    store.commit('SET_TOKEN', currentTokenInfo)
    return currentTokenInfo
  } else {
    return ''
  }
}

export function getTodayDate(gap) {
  let _gap = gap || '-'
  let bool
  let myDate = new Date()
  let Year = myDate.getFullYear()
  let Mouth = (myDate.getMonth() + 1) < 10 ? ('0' + (myDate.getMonth() + 1)) : (myDate.getMonth() + 1)
  let Day = (myDate.getDate()) < 10 ? ('0' + myDate.getDate()) : myDate.getDate()
  let currentDate = Year.toString() + _gap + Mouth.toString() + _gap + Day.toString()
  return currentDate
}
export function getTimeLeft(hour, minute, sec, milSec) {
  let x = new Date()
  let _sec = sec || 0
  let _milSec = milSec || 0
  x.setHours(hour, minute, _sec, _milSec)
  let y = new Date()
  let timeLeft = 24 * 3600 * 1000 - (y.getTime() - x.getTime())
  let hours = parseInt((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let minutes = parseInt((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
  let seconds = Math.round((timeLeft % (1000 * 60)) / 1000)

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return {
    h: hours,
    m: minutes,
    s: seconds
  }
}

export function getTimeLeftToDay(targetDate) {
  // 2019/6/26 10:00:00 或者 2019-6-26 10:00:00
  // 获取本地当前时间，截止时间 - 当前时间 = 倒计时时间
  let Today = new Date()
  let endDate = new Date(targetDate)
  let leftTime = endDate.getTime() - Today.getTime()
  let leftSecond = parseInt(leftTime / 1000)
  let Day = Math.floor(leftSecond / (60 * 60 * 24))
  let Hour = Math.floor((leftSecond - Day * 24 * 60 * 60) / 3600)
  let Minute = Math.floor((leftSecond - Day * 24 * 60 * 60 - Hour * 3600) / 60)
  let Second = Math.floor(leftSecond - Day * 24 * 60 * 60 - Hour * 3600 - Minute * 60)
  // if (Day < 0) {
  // clearInterval(timer) // 清除定时器
  // return
  // }
  return {
    d: Day,
    h: Hour,
    m: Minute,
    s: Second
  }
}
// 距离某个时间几个小时之后的时间
export function getTimeLeftToSomeHourLater(date, hours) {
  // 2019/6/26 10:00:00 或者 2019-6-26 10:00:00
  let _date = ''
  if (isIOS()) {
    _date = date.replace(/-/g, '/')
  } else {
    _date = date
  }
  let now = new Date().getTime()

  let later = new Date(_date).getTime() + 1000 * 60 * 60 * hours
  let resDate = new Date(later).getTime()

  let diff = resDate - now

  if (diff > 0) {
    let leftSecond = parseInt(diff / 1000)
    let Day = Math.floor(leftSecond / (60 * 60 * 24))
    let Hour = Math.floor((leftSecond - Day * 24 * 60 * 60) / 3600)
    let Minute = Math.floor((leftSecond - Day * 24 * 60 * 60 - Hour * 3600) / 60)
    let Second = Math.floor(leftSecond - Day * 24 * 60 * 60 - Hour * 3600 - Minute * 60)
    return {
      d: Day,
      h: Hour,
      m: Minute,
      s: Second
    }
  } else {
    return ''
  }

}
// 判断日期大小
export function getComparisonDateSize(date1, date2='2021-4-1 00:00:00') {
  // 2019/6/26 10:00:00 或者 2019-6-26 10:00:00
  let _date1 = '',_date2 = ''
  if (isIOS()) {
    _date1 = date1.replace(/-/g, '/')
    _date2 = date2.replace(/-/g, '/')
  } else {
    _date1 = date1
    _date2 = date2
  }
  let now = new Date().getTime()

  let time1 = new Date(_date1).getTime()
  let time2 = new Date(_date2).getTime()

  let diff = time1 - time2

  if (diff > 0) {
    return true
  } else {
    return false
  }

}

/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
*/  
export function formatTime(ts) {
  let gap = '-'
  if (isIOS()) {
    gap = '-'
  }
  var time = new Date(ts)
  var y = time.getFullYear()
  var m = time.getMonth()+1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var s = time.getSeconds()
  return y + gap + formatNumber(m) + gap + formatNumber(d) + ' ' + formatNumber(h) + ':' + formatNumber(mm) + ':' + formatNumber(s)
}

//数据转化  
export function formatNumber(m) {  
  return m < 10 ? '0' + m : m
}  

// 检查数组是否含有某元素  [1,2,3]是否含有3, 可传数组和字符串
export function findInArray(targ, item) {
  let bool = false
  if (targ) {
    if (typeof targ === 'string') {
      targ = targ.split(',')
    }
    if (targ.length) {
      for (let i = 0; i < targ.length; i++) {
        if (targ[i] === item) {
          bool = true
          break
        }
      }
    }
  }
  return bool
}

export function copyToClipboard(message, cb) {
  let input = document.createElement('input')
  input.value = message
  input.readOnly = 'readOnly'
  input.onfocus = input.blur()
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, input.value.length)
  document.execCommand('Copy')
  document.body.removeChild(input)
  cb()
}

export function transTime(time) {
  if (isIOS()) {
    return time.replace(/-/g, '/')
  } else {
    return time
  }
}

export function getInviteCode(id, type = 'P') {
  if (id > 100000) {
    return type + id.toString()
  }
  return type + (100000 + id).toString().replace(/^1/,'0')
}
export function getRandomSecNumber(max, min) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function uploadImgToQiniu (file, QiniuData) {
  // file图片的文本流   QiniuData{key：'',token:''} key：`KSAX/System/image/${new Date().getTime()}.png` token：七牛token
  let qiniuImgUrl = ''
  const axiosInstance = axios.create({
    withCredentials: false
  }); //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
  let data = new FormData();
  data.append('token', QiniuData.token);
  data.append('file', file);
  data.append('key', QiniuData.key);
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: 'POST',
      url: 'https://up.qiniup.com', //上传地址
      data: data,
      timeout: 30000, //超时时间，因为图片上传有可能需要很久
    }).then(data => {
      qiniuImgUrl = `http://qiniuimage.kuaishouaxiu.com/${data.data.key}`
      resolve(qiniuImgUrl)
      //上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
    }).catch(function (err) {
      //上传失败
      reject(err)
    });
  })
}

export class ScrollLoad {
  constructor ({
    pageSize = 10, 
    isLastWork = true,      // 是否判断最后一页
    isMaxPageIndex = false, // 是否有最大页数
    maxPageIndex = 30,      // 最大页数
    url, 
    resRoute, 
    data, 
    cb
  }) {
    this.isLast = false
    this.isLoading = false
    this.isEmpty = false
    this.pageIndex = 1
    this.pageSize = pageSize
    this.isMaxPageIndex = isMaxPageIndex
    this.maxPageIndex = maxPageIndex
    this.isLastWork = isLastWork
    this.url = url
    this.resRoute = resRoute // 'reponse/data'
    this.data = data
    this.cb = cb || function () {}
    this.resNum = null // 接口返回的商品数量
    this.loadData()
  }
  loadData () {
    if (this.isLoading) {
      return
    }
    // 返回数量为0，不在加载
    if (this.resNum === 0) {
      return
    }
    // 超过最大页
    if (this.isMaxPageIndex && this.pageIndex > this.maxPageIndex) {
      return
    }
    // 最后一页
    if (this.isLastWork && this.isLast) {
      return
    }
    this.isLoading = true
    const __URL = INTF[this.url]
    return __URL({
      ...this.data,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    }).then(res => {
      let { success } = res
      if (success) {
        const _data = this.getRes(res) || []
        this.isLast = _data.length < this.pageSize
        this.resNum = _data.length
        if (this.pageIndex === 1 && !_data.length) {
          this.isEmpty = true
        }
        const resData = {
          ...res,
          isEmpty: this.isEmpty,
          isLast: this.isLast
        }
        if ((this.isMaxPageIndex && this.pageIndex === this.maxPageIndex) || 
          !_data.length || 
          this.isLastWork && this.isLast) {
          resData.reachMaxPage = true
        }
        if (this.pageIndex === 1) {
          this.cb && this.cb(resData)
        }
        this.isLoading = false
        // if (!this.isLast) {
          this.pageIndex++
        // }
        return Promise.resolve(resData)
      } else {
        this.isLoading = false
        return Promise.resolve(res)
      }
    }).catch((err) => {
      this.isLoading = false
      return Promise.reject(new Error(err))
    })
  }
  getRes (res) {
    const p = this.resRoute.split('/')
    let r = null
    try {
      for (let i = 0; i < p.length; i++) {
        let data = r || res
        if (typeof data !== 'object') {
          break
        }
        r = data[p[i]]
      }
    } catch (e) {
      console.log(e)
    }
    return r || ''
  }
}